module.exports = __webpack_public_path__ + "static/media/tip_dog_twelveweek.a3500077.png";